export const digitAnim = {
	anim: (custom) => ({
		y: custom,
	}),
};

export const digitCont = {
	show: {
		transition: {
			staggerChildren: 1,
		},
	},
};
